import { KeyValue } from '@angular/common';
import { EnumToUiOption } from '../../models/enum-to-ui.model';

export function sortNumberEnumConstantInterfaceAsc(
    akv: KeyValue<number, EnumToUiOption>,
    bkv: KeyValue<number, EnumToUiOption>,
): number {
    const a = akv?.value?.order;
    const b = bkv?.value?.order;

    if (a === undefined || a === null || b === undefined || b === null) {
        return 0;
    }

    if (a > b) {
        return 1;
    }

    if (b > a) {
        return -1;
    }

    return 0;
}
